import styled from "styled-components";
import { ComponentType, ButtonHTMLAttributes } from "react";

interface VideoButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ComponentType<{ size?: number }>; 
}

export const Wrapper = styled.div`
  margin-top: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    align-items: flex-end;
    gap: 24px;
    margin-top: 48px;
  }
`;

export const FrameTitleWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    min-width: 45%;
    max-width: 500px;
  }
`;

export const Frame = styled.iframe`
  width: 100%;
  height: 180px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 360px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 24px;
  }
`;

export const TitleWrapper = styled.div`
  margin-top: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 32px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
  }
`;

export const ClientTitle = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  font-size: ${16 / 16}rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }
`;

export const ClientDescription = styled.p`
  font-size: ${14 / 16}rem;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  line-height: ${30 / 16}rem;
  color: ${({ theme }) => theme.palette.greyscale.grey600};
  margin-top: 8px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }
`;

export const AdvantagesWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 16px;
  column-gap: 40px;
  margin-top: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 32px;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 32px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 0;
    row-gap: 0;
    column-gap: 24px;
  }
`;

export const AdvantageWrapper = styled.div`
  border-radius: 8px;
  padding: 32px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid hsl(245, 60%, 96%);

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 40px 8px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    border: none;
    padding: 32px 8px;
  }
`;

export const IconWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.secondary.orange50};
  border-radius: 50%;
  padding: 16px;

  & svg {
    width: ${24 / 16}rem;
    height: ${24 / 16}rem;
    color: ${({ theme }) => theme.palette.secondary.orange500};
  }
`;

export const AdvantageTitle = styled.h6`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.greyscale.grey900};
  font-size: ${14 / 16}rem;
  margin-top: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }
`;

export const AdvantageDescription = styled.p`
  font-size: ${12 / 16}rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.greyscale.grey400};
  margin-top: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${14 / 16}rem;
  }
`;

export const VideoThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 360px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 24px;
  }
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export const PlayIcon = styled.div`
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-left: 20px solid white;
  border-bottom: 12px solid transparent;
  margin-left: 5px;
`;
export const StaticVideo = styled.video`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: 240px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    height: 240px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    height: 280px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 360px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 24px;
  }
`;

export const VideoButton = styled.button<VideoButtonProps>`
  position: absolute;
  width: auto;
  height: auto;
  bottom: 16px;
  right: 16px;
  background-color: ${({ theme }) => theme.palette.secondary.orange500};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 7px 12px;
    font-size: 14px;
    gap: 2px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    padding: 8px 14px;
    font-size: 16px;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    padding: 9px 16px;
    font-size: 18px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 10px 18px;
    font-size: 20px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 9px 16px;
    font-size: 18px;
  }

  &:hover {
    background: ${({ theme }) => theme.palette.primary.dark};
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0,0,0,0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  position: relative;
  width: 90%;
  max-width: 360px;
  background: white;
  padding: 0;
  border-radius: 8px;
  overflow: hidden; 
  min-height: 200px; 
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px; 
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  z-index: 1000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  @media (max-width: 768px) {
    top: 5px;
    right: 5px;
    font-size: 24px;
    width: 36px;
    height: 36px;
  }
`;
